// Contains all data provided by the twitch ext helper, and also
// any state directly related to twitch functionality, like "Grant ID"

import { queryParamsToObj } from '@/utils'
import * as M from '@/store/mutations'
import { twitch } from '@/twitch-ext'

const state = {
    auth: {},
    context: {},
    features: {},
    products: [],
    queryParams: queryParamsToObj(),
}

const mutations = {
    [M.SET_TWITCH_CONTEXT] (state, { context, changedProps }) {
        state.context = context
    },
    [M.SET_TWITCH_AUTH] (state, { auth }) {
        state.auth = auth
    },
    [M.SET_TWITCH_FEATURES] (state, { features }) {
        state.features = features
    },
    [M.SET_TWITCH_PRODUCTS] (state, { products }) {
        state.products = products
    },
}

const actions = {
    useBits ({ dispatch }, { sku }) {
        twitch.bits.useBits(sku)
    },
    showBitsBalance () {
        twitch.bits.showBitsBalance()
    },
    requestIdShare () {
        twitch.actions.requestIdShare()
    },
}

const getters = {
    isPopoutWindow: state => state.queryParams.popout === 'true',
    isMobile: state => state.queryParams.platform === 'mobile',
    // Is the extension iframe inside a video component slot?
    isVideoComponentWindow: (state, getters) => {
        return state.queryParams.anchor === 'component' && getters.isPageViewer
    },
    isPageViewer: state => state.queryParams.mode === 'viewer',
    isPageConfig: state => state.queryParams.mode === 'config',
    isBitsEnabled: (state, getters) => {
        const FORCE_ENABLED = true && getters.queryParams.state !== 'released'
        return state.features.isBitsEnabled || getters.isGuanzoSBox || FORCE_ENABLED
    },
    bitsProducts: state => state.products,
    userLanguage: state => state.queryParams.language,
    queryParams: state => state.queryParams,
    // Example config page url. This will only work in production.
    // https://dashboard.twitch.tv/u/guanzo/extensions/manage?configure=true&extensionID=6rh8h42nhnjmirlyxc0w9lbpmeehi0-2.0.12
    configPageUrl: (state, getters) => {
        const { channelLogin } = getters
        const clientId = process.env.TWITCH_EXT_CLIENT_ID
        const version = location.pathname.split('/')[2]

        return (
            `https://dashboard.twitch.tv/u/${channelLogin}/extensions/manage` +
            `?configure=true&extensionID=${clientId}-${version}`
        )
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
}
